import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { FuelFeesContribution } from '../../../../../../components/widgets/airport/providers/provider-products/fuel-products/fuel-costs/fuel-costs-contributions/fuel-costs-contribution';
import { connectNLP } from '../../../../../../utilities/connect-navigate';
import { Contributions } from '../../contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class FuelCostContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/fuelcosts/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return 'fuelproducts';
	}

	public getModalEndpoint() {
		return `/fuelcosts/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<FuelFeesContribution
				close={() => this.onModalClose()}
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				original={get(ctx.state, 'response')}
			/>
		);
	}
}

export const FuelCostContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(FuelCostContributionsComponent));
